import React from 'react'
import { Chip } from '@arnsbogroup/react-voicearchive'
import Icon from 'components/Icon'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import messages from './messages'

const ProjectProgress = ({ project }) => {
  const steps = [
    { key: 'scope', icon: 'circle-check', completed: project.isScoped },
    { key: 'lead', icon: 'circle-check', completed: project.isIdentified },
    { key: 'quote', icon: 'circle-check', completed: !!project.quotes.length },
    { key: 'acceptedQuote', icon: 'circle-check', completed: project?.quotes.find(({ accepted }) => accepted) },
    // { key: 'recording', icon: 'microphone-alt', completed: project.stage == 'IN_PROGRESS' },
    // { key: 'production', icon: 'wrench', completed: project.stage == 'IN_PROGRESS' },
    // { key: 'qa', icon: 'wrench', completed: project.stage == 'IN_PROGRESS' },
    // { key: 'delivery', icon: 'check', completed: project.stage == 'READY' },
  ]

  return (
    <div className="w-full flex flex-col lg:flex-row lg:items-center space-y-2 lg:space-y-0 lg:space-x-6">
      { steps.map(({ key, icon, completed }, i) => (
        <div
          key={`${i}-h1`}
          className={classNames('flex items-center font-medium text-sm space-x-2', {
            'text-gray-600': steps[i - 1]?.completed && !steps[i + 1]?.completed,
            'text-gray-400': !completed,
          })}
        >
          { completed ? (
            <Icon
              icon={completed ? ['fas', 'circle-check'] : icon}
              className={classNames({
                'text-positive': completed,
              })}
            />
          ) : steps[i - 1]?.completed && !steps[i + 1]?.completed ? (
            <span className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center" aria-hidden="true">
              <span className="animate-ping absolute h-4 w-4 rounded-full bg-yellow-200" />
              <span className="relative block h-2 w-2 rounded-full bg-yellow-400" />
            </span>
          ) : (
            <div className="w-2 h-2 inline-block rounded-full bg-gray-200" />
          ) }

          <span>
            { completed ? (
              <FormattedMessage {...messages[key]} />
            ) : (
              <FormattedMessage {...messages[steps[i - 1]?.completed ? `${key}Current` : key]} />
            ) }
          </span>

          { i < (steps.length - 1) &&
            <div className="hidden lg:block h-1 w-10 bg-gray-200 rounded" />
          }
        </div>
      ))}
    </div>
  )
}

export default ProjectProgress
